import { type MetricWithAttribution } from 'web-vitals';
import serverVars from 'server-vars';
import { LOCALE_US } from 'dibs-intl/exports/locales';
import { isValidMonitoringGroup } from 'dibs-monitoring/exports/constants.ts';
import { sendAnalyticsData } from './perfAnalyticsHelpers.ts';
import { type SupportedWebVital } from 'dibs-client-analytics/src/routes/cwvHandler.ts';
import { getForwardedHost } from './helpers.ts';

const validWebVitals = ['TTFB', 'LCP', 'INP', 'CLS'] as const;

const MOBILE = 'mobile' as const;
const DESKTOP = 'desktop' as const;

export const promTrackWebVitalsMetric = (metric: MetricWithAttribution): void => {
    const monitoringGroupName = serverVars.get('monitoringGroupName');
    const monitoringGroup = isValidMonitoringGroup(monitoringGroupName)
        ? monitoringGroupName
        : void 0;
    const requestLocale = serverVars.get('locale') === LOCALE_US ? LOCALE_US : `non-${LOCALE_US}`;
    const deviceType = serverVars.get('settings.deviceType') === MOBILE ? MOBILE : DESKTOP;

    if (monitoringGroup && validWebVitals.includes(metric.name as SupportedWebVital)) {
        sendAnalyticsData(
            `${location.protocol}//${location.host}/soa/client-analytics/web-vitals/`,
            {
                metricName: metric.name,
                metricValue: metric.value,
                metricRating: metric.rating,
                monitoringGroup,
                appVersion: serverVars.get('appVersion') || `0.0.0`,
                requestLocale,
                deviceType,
                userAgent: 'not-bot', // if this script is running, it means this is not an SSR-only bot
                forwardedHost: getForwardedHost(),
            }
        );
    }
};
